import React, { useRef } from "react";
import "./style.css";
import video from "../../assets/image/video-intro.mp4";

const VideoPlayer = () => {
  const videoRef = useRef(null);

  const handlePlayPause = () => {
    if (videoRef.current.paused) {
      videoRef.current.play();
    } else {
      videoRef.current.pause();
    }
  };

  const handleRestart = () => {
    videoRef.current.currentTime = 0;
    videoRef.current.play();
  };

  return (
    <div className="video-container p-4">
      <video ref={videoRef} className="video-player p-4" controls>
        <source src={video} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      {/* <div className="video-controls">
        <button onClick={handlePlayPause}>Play/Pause</button>
        <button onClick={handleRestart}>Restart</button>
      </div> */}
    </div>
  );
};

export default VideoPlayer;
